import { buriedPoint } from '@/utils/buriedPoint';

export const indexBuriedPointMyfunMap = {
  // 用于首页右侧，我的功能埋点
  my_order: 'myfun_order',
  my_coupon: 'myfun_my_coupons',
  coupon_center: 'myfun_coupons',
  exchange_area: 'myfun_exchange',
  my_balance: 'myfun_balance',
  invoice_information: 'myfun_invoice',
  delivery_address: 'myfun_Receiving_address',
  engineer_tool: 'myfun_Engineer_Tools',
  my_favorite: 'myfun_collect',
  invite_gift: 'myfun_Invitation_with_Gifts',
  lc_eda: 'myfun_EDA',
  university_plan: 'myfun_DXJH',
};
export const indexBuriedPointActivityTabsMap = {
  // 用于首页中间，活动专栏埋点
  discount: 'Activity_discount',
  hot: 'Activity_HOT_product',
  clearance: 'Activity_QC',
  mro_hot: 'Activity_MRO',
  stockpile: 'Activity_Clearing_warehouse',
  push_material: 'Activity_Standing_Push',
  rebate: 'Activity_Return_purchase_funds',
};

export const indexBuriedPointPopMap = {
  // 用于首页弹窗
  'group-user-pop': 'Group_advertising',
  'new-user-pop': 'Newcomer_benefits',
  'ad-pop': 'MID_FLOAT_ADV',
  'redpacket-rain': 'redpacket_rain',
};

export default function indexBuriedPoint(op = 'my_member', href, ty = 'click', ck) {
  if (href || ck) {
    buriedPoint({
      cp: 'index',
      ty,
      op,
      data: { hf: href, ck },
    });
  } else {
    buriedPoint({ cp: 'index', ty, op });
  }
}
